<template>
  <ResultCard :num-uri-string="numUriString" :result="result">
    <template v-slot:description
      ><div class="whitespace-no-wrap truncate ">
        {{ oneLineAddress }}
      </div></template
    >
  </ResultCard>
</template>

<script>
import ResultCard from "@/views/Home/Card/Result";

export default {
  name: "AddressCard",
  props: {
    numUriString: String,
    result: Object,
  },
  components: {
    ResultCard,
  },
  computed: {
    oneLineAddress() {
      if (!this.result?.lines) return null;
      const addressLines = this.result.lines || [];
      if (this.result.postcode) addressLines.push(this.result.postcode);
      if (this.result.country) addressLines.push(this.result.country);
      return addressLines?.join(", ");
    },
  },
};
</script>
